@if (authUserService.isTeacher()) {
  <app-teacher-layout> </app-teacher-layout>
} @else {
  <app-student-layout></app-student-layout>
}
